(() => {
  const rootSelector = '.pocket-aura-features';
  const trackSelector = '.pocket-aura-features__track';
  const slideSelector = '.pocket-aura-features__slide';
  const dotSelector = '.pocket-aura-features__dot';

  const setActiveDot = (dots, index) => {
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const getActiveIndex = (track, slides) => {
    const currentLeft = track.scrollLeft;
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - currentLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  };

  const initSection = (root) => {
    if (!root || root.dataset.featuresDotsReady === 'true') {
      return;
    }

    const track = root.querySelector(trackSelector);
    const slides = track ? Array.from(track.querySelectorAll(slideSelector)) : [];
    const dots = Array.from(root.querySelectorAll(dotSelector));

    if (!track || slides.length === 0 || dots.length === 0) {
      return;
    }

    root.dataset.featuresDotsReady = 'true';

    const updateDots = () => {
      setActiveDot(dots, getActiveIndex(track, slides));
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.slideIndex);
        const targetSlide = slides[index];

        if (!targetSlide) {
          return;
        }

        track.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'smooth'
        });
      });
    });

    let ticking = false;
    track.addEventListener(
      'scroll',
      () => {
        if (ticking) {
          return;
        }

        ticking = true;
        window.requestAnimationFrame(() => {
          updateDots();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateDots);
    updateDots();
  };

  const initAll = () => {
    document.querySelectorAll(rootSelector).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
  });
})();
